import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { CamposCustomizablesService } from './services/campos-customizables.service';
import { ICampoCustomizable, ICampoCustomizableRequest, ICampoCustomizableResponse } from './interfaces/campo-customizable.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-campos-customizables',
  templateUrl: './campos-customizables.component.html',
  providers: [MessageService]
})
export class CamposCustomizablesComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedCampo: ICampoCustomizable | null = null;
  dataSource: ICampoCustomizable[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'descripcion', header: 'Campo', sortable: true },
    { field: 'caracteristica', header: 'Características', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private camposCustomizablesService: CamposCustomizablesService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request: ICampoCustomizableRequest = {
      iAccion: 4,
      sCampo: '',
      sCaract: '',
      iNumReg: 9999
    };

    this.camposCustomizablesService.getCamposCustomizables(request).subscribe({
      next: (response: ICampoCustomizableResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los campos customizables'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los campos customizables'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedCampo = null;
    this.displayDialog = true;
  }

  openUpdate(row: ICampoCustomizable): void {
    this.selectedCampo = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: ICampoCustomizable): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este campo customizable?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.camposCustomizablesService.deleteCampoCustomizableReal(row.descripcion).subscribe({
          next: (response) => {
            const errorCode = response.data?.[0]?.error;
            if (errorCode === "0") {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Campo customizable eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: errorCode || 'Error al eliminar el campo customizable'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el campo customizable'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedCampo = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }
} 